import find from 'lodash/find';
import { Locale } from 'types/enums';

const queryParameterList = [
  {
    keyName: 'autoplay',
    type: 'boolean',
    defaultValue: false,
  },
  {
    keyName: 'languageCode',
    type: 'string',
    defaultValue: 'en',
    availableValues: ['en', 'es'],
  },
  {
    keyName: 'locale',
    type: 'string',
    defaultValue: Locale.ENGLISH,
    availableValues: [Locale.ENGLISH, Locale.SPANISH],
  },
];

export function getFixedQueryParamObject(queryParamObject) {
  let fixedQueryParamObject = Object.assign({}, queryParamObject);

  queryParameterList.forEach(function (queryParamData) {
    if (queryParamObject[queryParamData.keyName]) {
      fixedQueryParamObject =
        typeof queryParamObject[queryParamData.keyName] !== queryParamData.type
          ? _handleTypeConflict(fixedQueryParamObject, queryParamData)
          : _checkAndHandleValueConflict(fixedQueryParamObject, queryParamData);
    }
  });

  return fixedQueryParamObject;
}

function _handleTypeConflict(queryParamObject, keyData) {
  return Object.assign({}, queryParamObject, {
    [keyData.keyName]: keyData.defaultValue,
  });
}

function _checkAndHandleValueConflict(queryParamObject, keyData) {
  // If we find a value conflict, we replace the faulty value with the default one
  if (
    keyData.availableValues &&
    !find(
      keyData.availableValues,
      (availableValue) => availableValue === queryParamObject[keyData.keyName]
    )
  ) {
    return Object.assign({}, queryParamObject, {
      [keyData.keyName]: keyData.defaultValue,
    });
  } else {
    // Otherwise, we just send back the input object
    return queryParamObject;
  }
}

// Query string format:
// ?param1=true&param2=20&param3="someString"[&paramN=valueN]
export function parseQueryString(queryString) {
  const decodedQueryString = decodeURIComponent(queryString);
  const rawKeyValueList = decodedQueryString
    .substring(1, decodedQueryString.length)
    .split('&');
  const processedParams = {};

  rawKeyValueList.forEach((rawKeyValue) => {
    try {
      processedParams[rawKeyValue.split('=')[0]] = JSON.parse(
        rawKeyValue.split('=')[1]
      );
    } catch (err) {
      processedParams[rawKeyValue.split('=')[0]] = JSON.parse(
        `"${rawKeyValue.split('=')[1]}"`
      );
    }
  });

  return processedParams;
}
